import script from "./email-reply.vue?vue&type=script&setup=true&lang=js"
export * from "./email-reply.vue?vue&type=script&setup=true&lang=js"

import "./email-reply.vue?vue&type=style&index=0&id=2d3bafd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3bafd4"]])

export default __exports__